function PlusColorChip(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 46 46"
      className={props.className}
      style={{ fillRule: "evenodd", clipRule: "evenodd" }}
    >
      <g transform="matrix(1,0,0,1,-19.4384,-71.4384)">
        <g id="Color-Chip_11">
          <circle
            id="Color-Chip-Large-Disco-Tech"
            cx="42"
            cy="94"
            r="20.5"
            style={{
              fill: "rgb(238,238,238)",
              stroke: "rgb(158,158,158)",
              strokeWidth: "1px",
              strokeDasharray: "4,2",
            }}
          />
          <path
            id="_-"
            d="M43.042,103L43.042,94.937L51,94.937L51,92.921L43.042,92.921L43.042,85L40.976,85L40.976,92.921L33,92.921L33,94.937L40.976,94.937L40.976,103L43.042,103Z"
            style={{ fill: "rgb(158,158,158)", fillRule: "nonzero" }}
          />
        </g>
      </g>
    </svg>
  );
}

export default PlusColorChip;
